import React from 'react'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import PropTypes from 'prop-types'
import { noop } from 'jquery'
// import { errorMessage } from '../../constants/errorMessage'
import GooglePayButton from '@google-pay/button-react'

const GooglePayHL = (props) => {
    // const [isRendered, setIsRendered] = useState(true)

    const { faciltyData, payableAmount, getValues, onSubmit, setIsSubmittingForm, setIsLoading, notify } = props
    

    const getToken = (paymentResponse) => {
        setIsSubmittingForm(true)
        setIsLoading(true)
        if(paymentResponse?.paymentMethodData?.tokenizationData?.token) {
            const formData = getValues()
            const finalData = {...formData, walletPay: paymentResponse?.paymentMethodData?.tokenizationData?.token}
            finalData.paymentMethods = 'GPAY'
            onSubmit(finalData, 0)
        } else {
            notify('error', 'Token generation error')
            const formData = getValues()
            const finalData = {...formData, walletPay : ''}
            finalData.paymentMethods = 'GPAY'
            onSubmit(finalData, 0)
        }
    }

    return (
        <div className='payButton px-2 mx-2 mb-2 d-flex justify-content-center' id='google-pay-button'>
            <GooglePayButton
                buttonColor='default'
                buttonType='buy'
                // environment={getConfigDetails?.HL_GooglePay.environment}
                environment={(faciltyData?.facility_payment_details?.heartland_payment_env == 'production') ? 'PRODUCTION': 'TEST'}
                paymentRequest={{
                    apiVersion: 2,
                    apiVersionMinor: 0,
                    allowedPaymentMethods: [
                        {
                            type: 'CARD',
                            parameters: {
                                allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                                allowedCardNetworks: ['AMEX', 'DISCOVER', 'INTERAC', 'JCB', 'MASTERCARD', 'VISA'],
                            },
                            tokenizationSpecification: {
                                type: 'PAYMENT_GATEWAY',
                                // parameters: getConfigDetails?.HL_GooglePay.parameters,
                                parameters: {
                                    gateway: 'globalpayments',
                                    gatewayMerchantId: faciltyData?.facility_payment_details?.heartland_merchant_id ? faciltyData?.facility_payment_details?.heartland_merchant_id : '',
                                },
                            },
                        },
                    ],
                    // merchantInfo: getConfigDetails?.HL_GooglePay.merchantInfo,
                    merchantInfo: {
                        merchantId: faciltyData?.facility_payment_details?.heartland_merchant_id ? faciltyData?.facility_payment_details?.heartland_merchant_id : '12345678901234567890',
                        merchantName: faciltyData?.facility_payment_details?.heartland_merchant_name ? faciltyData?.facility_payment_details?.heartland_merchant_name : 'Demo Merchant',
                    },
                    transactionInfo: {
                        totalPriceStatus: 'FINAL',
                        totalPriceLabel: 'Total',
                        totalPrice: Number(payableAmount)?.toFixed(2),
                        currencyCode: 'USD',
                        countryCode: 'US',
                    },
                }}
                onLoadPaymentData={getToken}
            />
        </div>
    )
}
GooglePayHL.propTypes = {
   faciltyData: PropTypes.object, 
   getValues: PropTypes.func, 
   onSubmit: PropTypes.func,
   setIsSubmittingForm: PropTypes.func,
   setIsLoading: PropTypes.func,
   notify: PropTypes.func,
   payableAmount: PropTypes.number,
}

GooglePayHL.defaulProps = {
    faciltyData: EMPTY_OBJECT,
    getValues: noop, 
    onSubmit: noop,
    setIsSubmittingForm: noop,
    setIsLoading: noop,
    notify: noop,
    payableAmount: 0,
}
export default GooglePayHL
